import { render, staticRenderFns } from "./prTrait.vue?vue&type=template&id=1214741c&scoped=true&"
import script from "./prTrait.vue?vue&type=script&lang=js&"
export * from "./prTrait.vue?vue&type=script&lang=js&"
import style0 from "./prTrait.vue?vue&type=style&index=0&id=1214741c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214741c",
  null
  
)

export default component.exports